import map from 'lodash/map';

import * as actions from 'actions/importJobs';
import { getListPageSuccessNewData } from '../utils';

export const defaultState = {
  loading: true,
  data: [],
  links: {},
  paging: false,
  error: false,
  dataLoaded: false,
};

export default function importJobs(state = defaultState, action) {
  switch (action.type) {
    case actions.LOAD:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case actions.PAGE_START:
      return {
        ...state,
        paging: true,
        error: false,
        dataLoaded: false,
      };
    case actions.PAGE_SUCCESS: {
      const { links } = action.payload;
      const newLinks = Object.keys(links).reduce(
        (obj, link) => ({ ...obj, [link]: decodeURIComponent(links[link]) }),
        {},
      );

      return {
        ...state,
        data: [...state.data, ...action.payload.data],
        links: newLinks,
        total: action.payload.total,
        paging: false,
        error: false,
      };
    }
    case actions.LOAD_SUCCESS: {
      const { data, links, total } = action.payload;

      const newLinks = Object.keys(links).reduce(
        (obj, link) => ({ ...obj, [link]: decodeURIComponent(links[link]) }),
        {},
      );

      return {
        ...state,
        data: getListPageSuccessNewData(state, data, links),
        total,
        links: newLinks,
        loading: false,
        error: false,
        dataLoaded: true,
      };
    }
    case actions.LOAD_IMPORT_SUCCESS: {
      const item = action.payload;
      const data = map(state.data, oldItem =>
        oldItem.id === item.id ? item : oldItem,
      );

      return {
        ...state,
        data,
      };
    }
    case actions.PAGE_FAIL:
    case actions.LOAD_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
